export interface IText {
    dashboard: string
    trailer: string
    truck: string
    manage: string
    van: string
    car: string
}

const translations: Map<string, IText> = new Map<string, IText>();

translations.set('fr', {
    dashboard: "Tableau de bord",
    trailer: "Remorques",
    truck: "Camions",
    manage: "Gestion",
    van: "Camionnettes",
    car: "Voitures"
})
export default translations;
